/**
 * Подпись входа в обращения — один источник на всё приложение.
 *
 * Входов два: строка справа вверху (`App.js`) и пункт меню под аватаром
 * (`AppSidebar.js`). Окно за ними одно, поэтому и подпись обязана быть одна:
 * два разных имени человек считает разными местами и ищет «то, другое».
 * Ровно так и разъехалось — верх звал «Обратная связь», меню «Сообщить о
 * проблеме».
 *
 * 🔴 Текст называет ОБА повода. «Обратная связь» читается как «похвалить или
 * поругать», и человек со сломанной записью её не нажимает (Юля Зарубина,
 * 18.09.2026). Сужать до «Сообщить о проблеме» тоже нельзя: окно принимает и
 * предложения — чип «Предложение» в нём есть с самого начала. Решение
 * Владимира 19.09.2026.
 */
export const FEEDBACK_ENTRY_LABEL = 'Проблема или идея';

/**
 * Числа из `/feedback/unread`: `answers` — непрочитанные решения (по ним
 * всплывает «вам ответили»), `total` — они же плюс нераскрытые сообщения
 * «Что нового» (это число на кнопке). О сообщениях всплывашки нет намеренно:
 * она дёргала бы каждого при входе (решение владельца 12.10.2026).
 */
export function unreadTotals(data) {
  const num = (v) => (Number.isFinite(v) && v > 0 ? v : 0);
  const answers = num(data?.count);
  return { answers, total: answers + num(data?.news) };
}
